<script>
  // Import Svelte
  import { onMount, createEventDispatcher, setContext } from "svelte";
  import { log, announce } from "./Logging.svelte";

  // Properties and defaults
  let a = "c:UserState"; // Log name
  export let user;
  export let firebase;
  export let db;
  // True while "Keep windows ready" is on: friends may hold a quiet link to this device.
  export let ready = false;
  let userStatus = "unavailable";

  let userStateLoaded = false;
  let status = "unavailable";
  const dispatch = createEventDispatcher();

  setContext("statusUpdater", {
    makeAvailable: () => {
      updateStatus("available");
    },
    makeUnavailable: () => {
      updateStatus("unavailable");
    }
  });

  function updateStatus(eventStatus) {
    let b = "f:updateStatus";
    console.log(a, b, "run");
    let new_status = "unavailable";
    if (eventStatus == "available") {
      new_status = "available";
    }
    if (userStatus !== new_status) {
      console.log(a, b, ": Update status to");
      db.collection("Status")
        .doc(user.uid)
        .set({
          online: true,
          status: new_status,
          ready: !!ready
        })
        .then(function(result) {
          console.log(
            a,
            b,
            "- Firestore status updated from",
            userStatus,
            "to",
            new_status
          );
          // Update the debug stats
          userStatus = new_status;
          dispatch("debugStatus", {
            property: "Status",
            value: userStatus
          });
        })
        .catch(function(error) {
          console.error(a, b, "- Error updating status:", error);
        });
    }
  }

  // Firebase functions
  function firebaseStatus(uid) {
    let b = "f:firebaseStatus";
    // Create a reference to this user's specific status node.
    // This is where we will store data about being online/offline.
    var userStatusDatabaseRef = firebase.database().ref("/status/" + uid);

    // We'll create two constants which we will write to
    // the Realtime database when this device is offline
    // or online.
    var isOfflineForDatabase = {
      online: false,
      last_updated: firebase.database.ServerValue.TIMESTAMP
    };

    var isOnlineForDatabase = {
      online: true,
      last_updated: firebase.database.ServerValue.TIMESTAMP
    };

    // Create a reference to the special '.info/connected' path in
    // Realtime Database. This path returns `true` when connected
    // and `false` when disconnected.
    firebase
      .database()
      .ref(".info/connected")
      .on("value", function(snapshot) {
        console.log(
          "Realtime Database connected: " + snapshot.val() +
          " at " + new Date().toISOString().slice(11, 19) +
          " (page " + document.visibilityState + ")"
        );
        // If we're not currently connected, don't do anything.
        if (snapshot.val() == false) {
          return;
        }
        // If we are currently connected, then use the 'onDisconnect()'
        // method to add a set which will only trigger once this
        // client has disconnected by closing the app,
        // losing internet, or any other means.
        userStatusDatabaseRef
          .onDisconnect()
          .set(isOfflineForDatabase)
          .then(function() {
            console.log("onDisconnect request resolved");
            // The promise returned from .onDisconnect().set() will
            // resolve as soon as the server acknowledges the onDisconnect()
            // request, NOT once we've actually disconnected:
            // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

            // We can now safely set ourselves as 'online' knowing that the
            // server will mark us as offline once we lose connection.
            userStatusDatabaseRef.set(isOnlineForDatabase);
            setTimeout(function() {
              // Re-assert the detector's last known state. After a brief
              // disconnect the server has marked us unavailable and cleared
              // any call; sending "available" again lets the server pair us
              // back up without waiting for the face to leave and return.
              var resumed = userStatus === "available" ? "available" : "unavailable";
              db.collection("Status")
                .doc(user.uid)
                .set({
                  online: true,
                  status: resumed,
                  ready: !!ready
                })
                .then(function(result) {
                  console.log(a, b, ": Update status to true " + resumed);
                  dispatch("debugStatus", {
                    property: "Status",
                    value: resumed
                  });
                });
              userStateLoaded = true;
            }, 1500);
          });
      });
  }

  function initProcess() {
    let b = "f:initProcess";
    console.log(a, b, ": init");
    userStateLoaded = false;
    window.addEventListener("online", function() {
      console.log("Browser reports network online at " + new Date().toISOString().slice(11, 19));
    });
    window.addEventListener("offline", function() {
      console.log("Browser reports network offline at " + new Date().toISOString().slice(11, 19));
    });
    firebaseStatus(user.uid);
  }

  // Sign-out paths call this before auth.signOut(): the offline write must go out
  // while the account is still signed in, or the rules reject it and the device
  // stays "online" until its socket drops.
  let offlineWritten = false;
  export function goOffline() {
    return destroyProcess();
  }

  function destroyProcess() {
    let b = "f:destroyProcess";
    if (offlineWritten) return Promise.resolve();
    offlineWritten = true;
    return db.collection("Status")
      .doc(user.uid)
      .set({
        online: false,
        status: "unavailable",
        ready: false
      })
      .then(function(result) {
        console.log(a, b, "- Firestore status updated to false unavailable.");
        var userStatusDatabaseRef = firebase
          .database()
          .ref("/status/" + user.uid);
        var isOfflineForDatabase = {
          online: false,
          last_updated: firebase.database.ServerValue.TIMESTAMP
        };
        userStatusDatabaseRef.set(isOfflineForDatabase).then(function(result) {
          console.log(a, b, ": Set firebase to offline");
        });
        dispatch("debugStatus", {property: "Status", value: "", clear: true});
      })
      .catch(function(error) {
        console.error(a, ": Error writing document: ", error);
      });
  }

  onMount(() => {
    announce("UserState Mounted");
    let b = "f:onMount";
    if (user) {
      initProcess();
    } else {
      console.log(a, b, ": Error user is not set");
    }
    return () => {
      destroyProcess();
    };
  });
</script>

{#if userStateLoaded}

  <slot />
{/if}
